import React from 'react'
import style from './style.module.scss'

const SlideWrapper = ({ icon, comment, avatar, userName, userRole }) => {
  return (
    <div className={style.slideWrapper}>
      <div className={style.brandIcon}>
        <img src={icon} alt="Brand Icon" width="70px" />
      </div>
      <div className={style.comment}>{comment}</div>
      <div className={style.commentBy}>
        <div className="">
          <img
            className={style.commentByAvatar}
            src={avatar}
            alt="User Icon"
            width="38px"
            style={{ borderRadius: '50%' }}
          />
        </div>
        <div className={style.commentByDetails}>
          <div className={style.commentByName}>{userName}</div>
          <div className={style.commentByRole}>{userRole}</div>
        </div>
      </div>
    </div>
  )
}

export default SlideWrapper
